import choVayConst from "constants/choVayConst";
import { LaiSuatText2 } from "constants/choVayConst";
import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const TableTaiSan = ({ contentThongTinTaiSan }) => {
  return (
    <>
      <div className="table-responsive table-2">
        <table className="table table-bordered mb-0">
          <thead>
            <tr>
              <th>Mã tài sản</th>
              <th>Chi tiết</th>
            </tr>
          </thead>
          <tbody>
            <tr className="active">
              <td>{contentThongTinTaiSan.MaTaiSan}</td>
              <td>{contentThongTinTaiSan.ChiTiet}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
